/**
 * 361 Sleep — Header
 * Mobile drawer + shop dropdown (تسوق الآن) + cart drawer open.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function openCartDrawer(trigger) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(trigger);
      return true;
    }
    return false;
  }

  function initCartLinks(root) {
    if (!root) return;

    root.querySelectorAll('#cart-icon-bubble, #cart-icon-bubble--mobile').forEach(function (cartLink) {
      if (!cartLink || cartLink._cart361Ready) return;
      cartLink._cart361Ready = true;

      cartLink.addEventListener('click', function (event) {
        if (openCartDrawer(cartLink)) {
          event.preventDefault();
        }
      });
    });
  }

  function initShopDropdown(shop) {
    if (!shop || shop._shop361Ready) return;
    shop._shop361Ready = true;

    var trigger = shop.querySelector('[data-header-shop-trigger]');
    var menu = shop.querySelector('[data-header-shop-menu]');
    if (!trigger || !menu) return;

    function isOpen() {
      return shop.classList.contains('is-open');
    }

    var transitionTimeout;
    function setOpen(open) {
      if (open === isOpen()) return;
      clearTimeout(transitionTimeout);

      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (open) {
        menu.hidden = false;
        // force reflow
        void menu.offsetHeight;
        shop.classList.add('is-open');
      } else {
        shop.classList.remove('is-open');
        transitionTimeout = setTimeout(function () {
          menu.hidden = true;
        }, 250); // Matches CSS transition duration
      }
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(!isOpen());
    });

    // Elegant Hover Interaction on Desktop
    var hoverTimeout;
    shop.addEventListener('mouseenter', function () {
      if (window.matchMedia('(min-width: 990px)').matches) {
        clearTimeout(hoverTimeout);
        setOpen(true);
      }
    });

    shop.addEventListener('mouseleave', function () {
      if (window.matchMedia('(min-width: 990px)').matches) {
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(function () {
          setOpen(false);
        }, 150); // Short delay to prevent accidental closure
      }
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('click', function (event) {
      if (!isOpen()) return;
      if (shop.contains(event.target)) return;
      setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) {
        setOpen(false);
        trigger.focus();
      }
    });

    shop._shop361SetOpen = setOpen;
  }

  function initHeader(root) {
    if (!root || root._header361Ready) return;
    root._header361Ready = true;

    var toggle = root.querySelector('[data-header-toggle]');
    var menu = root.querySelector('[data-header-menu]');
    var backdrop = root.querySelector('[data-header-backdrop]');
    var closeBtn = root.querySelector('[data-header-close]');
    var links = root.querySelectorAll('[data-header-link]');

    root.querySelectorAll('[data-header-shop]').forEach(initShopDropdown);
    initCartLinks(root);

    if (!toggle || !menu) return;

    var lastFocus = null;

    function isOpen() {
      return root.classList.contains('is-open');
    }

    function closeShopMenus() {
      root.querySelectorAll('[data-header-shop]').forEach(function (shop) {
        if (typeof shop._shop361SetOpen === 'function') {
          shop._shop361SetOpen(false);
        }
      });
    }

    function setOpen(open) {
      if (open === isOpen()) return;

      if (open) {
        lastFocus = document.activeElement;
        menu.hidden = false;
        void menu.offsetWidth;
        root.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'إغلاق القائمة');
        document.body.classList.add('header361-locked');
        window.setTimeout(function () {
          if (closeBtn) closeBtn.focus();
        }, 40);
      } else {
        root.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'فتح القائمة');
        document.body.classList.remove('header361-locked');
        closeShopMenus();
        window.setTimeout(function () {
          if (!isOpen()) menu.hidden = true;
        }, 420);
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus();
        } else {
          toggle.focus();
        }
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(!isOpen());
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setOpen(false);
      });
    }

    if (backdrop) {
      backdrop.addEventListener('click', function () {
        setOpen(false);
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) {
        event.preventDefault();
        setOpen(false);
      }
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 990px)').matches && isOpen()) {
        setOpen(false);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-header361]').forEach(initHeader);
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-header361]') ||
        (event.target.matches && event.target.matches('[data-header361]') ? event.target : null)
      : null;
    if (!root) return;
    root._header361Ready = false;
    root.querySelectorAll('[data-header-shop]').forEach(function (shop) {
      shop._shop361Ready = false;
    });
    root.querySelectorAll('#cart-icon-bubble, #cart-icon-bubble--mobile').forEach(function (link) {
      link._cart361Ready = false;
    });
    initHeader(root);
  });
})();
